import { createTheme } from "@mui/material/styles";
import { height } from "@mui/system";

const theme = createTheme({
  typography: {
    fontFamily:
      "SamsungOne,'Microsoft JhengHei', 'inherit', 微软雅黑, Simsun, 宋体, arial, sans-serif",
  },
  palette: {
    mode: "light",
    primary: {
      main: "#000000", // 主色變黑色
      contrastText: "#ffffff", // primary 按鈕上字變白色
    },
    text: {
      primary: "#000000", // 正文變黑色
      secondary: "#333333", // 次要字體變深灰
    },
    background: {
      default: "#ffffff", // 頁面背景白色
      paper: "#ffffff", // 元件背景白色
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: "14px", // default < 425

          [theme.breakpoints.up(425)]: {
            fontSize: "15px", // 425px - 768px
          },
          [theme.breakpoints.up(768)]: {
            fontSize: "16px", // >= 768px
          },
        }),
      },
    },
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true, // ✅ 全局關閉 scroll lock
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent", // ✅ 移除背景色
          "&:hover": {
            backgroundColor: "transparent",
          },
          "&.Mui-focused": {
            backgroundColor: "transparent",
          },
          "&.Mui-disabled": {
            backgroundColor: "transparent", // 👈 解決 disabled 有灰底
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: "12px 16px", // ⬅️ 根據你想要的上下左右 padding 去調整
        },
        icon: {
          color: "#000", // 改箭咀顏色
          fontSize: "20px", // 改箭咀大小
          right: 12, // 微調箭咀位置（相對 padding）
          top: "calc(50% - 12px)", // 垂直置中
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          padding: "12px 16px", // ⬅️ 根據你想要的上下左右 padding 去調整
          whiteSpace: "normal",
          wordBreak: "break-word",
          textAlign: "center",
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          margin: "0 10px", // 對應 .dropdown-divider-wrapper 的 padding
          backgroundColor: "#000",
          height: "1px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            padding: "0", // 移除 default padding
            backgroundColor: "transparent",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ccc", // 預設邊框顏色
            },
            "&:hover fieldset": {
              borderColor: "#999", // hover 邊框顏色
            },
            "&.Mui-focused fieldset": {
              borderColor: "#000", // focus 邊框顏色
            },
            "&.Mui-disabled": {
              backgroundColor: "transparent", // disabled 狀態底色
            },
          },
          "& .MuiInputLabel-root": {
            fontSize: "14px",
          },
          "& .MuiInputBase-input": {
            padding: "13px 16px", // 輸入框 padding
            fontSize: "14px",
            height: "21px",
          },
        },
      },
    },
  },
  transitions: {
    // So we have `transition: none;` everywhere
    create: () => "none",
  },
});

export default theme;
